module.exports = __webpack_public_path__ + "img/issue-icon18.c91fbda.png";